import { useState } from "react";

export default function Hero() {
  const [videoOpen, setVideoOpen] = useState(false);

  return (
    <section id="home" className="relative w-full h-[92vh] min-h-[560px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Serene%20stylized%20oriental%20pastoral%20wonderland%20with%20terraced%20emerald%20farm%20fields%2C%20traditional%20bamboo%20and%20timber%20pavilions%2C%20winding%20stone%20paths%20and%20a%20mirror%20lake%2C%20soft%20morning%20mist%2C%20warm%20golden%20sunrise%20light%2C%20lush%20green%20vegetation%20with%20harvest%20amber%20tones%2C%20artistic%20painterly%20illustration%20style%2C%20harmonious%20dreamy%20composition&width=1600&height=900&seq=home-hero-1&orientation=landscape"
          alt="味聚华夏农耕酵素农场 · 九宫八卦田园仙境"
          title="味聚华夏农耕酵素农场 · 田园仙境"
          fetchPriority="high"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center flex flex-col items-center">
        <span className="animate-fade-up inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur text-white text-xs md:text-sm font-medium">
          <i className="ri-seedling-line"></i>
          工程代号 · 三明农链工程
        </span>

        <h1 className="animate-fade-up font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mt-6 leading-tight" style={{ animationDelay: "120ms" }}>
          味聚华夏农耕酵素农场
        </h1>

        <p className="animate-fade-up text-white/90 text-base md:text-xl mt-5 max-w-3xl leading-relaxed" style={{ animationDelay: "240ms" }}>
          预订单众筹认种农业 · 城乡双向田园重构 · 农文旅社交 · 城市迷你植物森林改造
          <br className="hidden md:block" />
          以人与人、组织与组织关系为核心的产业共生平台
        </p>

        <div className="animate-fade-up flex flex-col sm:flex-row items-center gap-4 mt-8" style={{ animationDelay: "360ms" }}>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-7 py-3 rounded-md bg-primary-500 text-white text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-seedling-line"></i>
            立即认种一块田
          </a>
          <button
            type="button"
            onClick={() => setVideoOpen(true)}
            className="inline-flex items-center gap-2 px-7 py-3 rounded-md bg-white/15 backdrop-blur text-white text-sm md:text-base font-medium hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line"></i>
            观看项目宣传片
          </button>
        </div>

        <div className="animate-fade-up flex flex-wrap items-center justify-center gap-x-8 gap-y-3 mt-10 text-white/80 text-xs md:text-sm" style={{ animationDelay: "480ms" }}>
          {["全国多点农场", "16 大主题园", "酵素农法标准", "区块链溯源"].map((item) => (
            <span key={item} className="inline-flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400"></i>
              {item}
            </span>
          ))}
        </div>
      </div>

      {videoOpen && (
        <div className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center p-4" onClick={() => setVideoOpen(false)}>
          <div className="relative w-full max-w-3xl" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              onClick={() => setVideoOpen(false)}
              className="absolute -top-10 right-0 w-9 h-9 rounded-full bg-white/20 flex items-center justify-center text-white cursor-pointer"
              aria-label="关闭"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
            <div className="relative aspect-video rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Panoramic%20stylized%20sunset%20over%20rolling%20terraced%20farm%20fields%20with%20bamboo%20pavilions%20and%20distant%20mountains%2C%20warm%20golden%20and%20deep%20green%20gradient%20sky%2C%20peaceful%20inspiring%20atmosphere%2C%20artistic%20painterly%20illustration%2C%20rich%20warm%20color%20palette%2C%20dreamy%20composition&width=1200&height=675&seq=home-video-1&orientation=landscape"
                alt="味聚华夏农耕酵素农场宣传片"
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-white/25 backdrop-blur flex items-center justify-center">
                  <i className="ri-play-fill text-3xl md:text-4xl text-white"></i>
                </span>
              </div>
            </div>
            <p className="text-center text-white/80 text-sm mt-4">宣传片即将上线，敬请期待</p>
          </div>
        </div>
      )}
    </section>
  );
}